<template>
  <v-dialog v-model="dialog" max-width="680">
    <template #activator="{on}">
        <v-btn v-on=on v-if='$can("price", "Product")' :disabled="fields.length == 0">Add field</v-btn>
    </template>
    <v-card :disabled="loading" :loading="loading">
        <v-card-title>Add fields</v-card-title>
        <v-card-text>
            <v-select 
                v-model="model.handle"
                label="Field"
                :items="fields"
            />
            <v-text-field
                v-model="model.value"
                label="Value"
            />
        </v-card-text>
        <v-card-actions>
            <v-btn @click="dialog=false">Cancel</v-btn>
            <v-spacer />
            <v-btn @click="save" color="primary">Save</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
    props: {
        product: {
            type: Object,
            required:true
        }
    },
    data: () => ({
        dialog:false,
        model: {
            handle: null
        },
    }),
    computed:{
        ...mapGetters("products", ["loading"]),
        fields(){
            if(this.product.type == 'IRON'){
                return [
                    {text:'ironTypeId',value:'ironTypeId'},
                    {text:'dominantHand',value:'dominantHand'}
                ];
            }else if(this.product.type == 'IRON SHAFT') {
                return [
                    {text:'ironTypeId',value:'ironTypeId'},
                ];
            }
            return []
        }
    },
    methods:{
        ...mapActions("products", ["addField"]),
        save(){
            this.addField({
                productId:this.product.id,
                field:this.model})
                .then(({product}) => {
                    this.$emit("saved", product)
                })
                .finally(() => {
                    this.dialog = false;
                })
        }
    }

}
</script>

<style>

</style>